import ApiAdapter from '../apiAdapter.js';
let PROCESSOR = null;
const setProcessor = (strategy) => {
    PROCESSOR = strategy;
};
const getProcessor = () => PROCESSOR;
const get = async (request, options) => {
    if (!PROCESSOR) {
        return Promise.reject(new Error('No data processor configured'));
    }
    try {
        const response = await ApiAdapter.callApi(request, {
            cache: false,
            ...options,
        });
        const validationError = PROCESSOR.validateResponse(response, request);
        if (validationError) {
            return Promise.reject(validationError);
        }
        return Promise.resolve(PROCESSOR.processResponse(response, request));
    }
    catch (error) {
        return Promise.reject(error);
    }
};
export default {
    get,
    setProcessor,
    getProcessor,
};
